export interface AppSettings {
  ocrApiKeys: string[];
  ncbiApiKey: string;
  ncbiEmail: string;
  ncbiTool: string;
}

const APP_SETTINGS_KEY = 'seqreader.byok.settings';

export const DEFAULT_APP_SETTINGS: AppSettings = {
  ocrApiKeys: [],
  ncbiApiKey: '',
  ncbiEmail: '',
  ncbiTool: 'seqreader',
};

function normalizeList(list: string[]) {
  const dedup = new Set<string>();
  for (const item of list) {
    const trimmed = item.trim();
    if (trimmed) {
      dedup.add(trimmed);
    }
  }
  return Array.from(dedup);
}

function parseStringList(value: unknown) {
  if (Array.isArray(value)) {
    return normalizeList(value.map(item => (typeof item === 'string' ? item : '')));
  }
  if (typeof value === 'string') {
    return normalizeList(value.split(/[\n,;，；]/).map(item => item.trim()));
  }
  return [] as string[];
}

export const loadAppSettings = (): AppSettings => {
  if (typeof window === 'undefined') {
    return DEFAULT_APP_SETTINGS;
  }

  try {
    const raw = window.localStorage.getItem(APP_SETTINGS_KEY);
    if (!raw) return DEFAULT_APP_SETTINGS;

    const parsed = JSON.parse(raw) as Record<string, unknown>;
    const legacyOcrApiKey = typeof parsed.ocrApiKey === 'string' ? parsed.ocrApiKey : '';

    return {
      ocrApiKeys: normalizeList([...parseStringList(parsed.ocrApiKeys), legacyOcrApiKey]),
      ncbiApiKey: typeof parsed.ncbiApiKey === 'string' ? parsed.ncbiApiKey : '',
      ncbiEmail: typeof parsed.ncbiEmail === 'string' ? parsed.ncbiEmail : '',
      ncbiTool:
        typeof parsed.ncbiTool === 'string' && parsed.ncbiTool.trim()
          ? parsed.ncbiTool.trim()
          : DEFAULT_APP_SETTINGS.ncbiTool,
    };
  } catch {
    return DEFAULT_APP_SETTINGS;
  }
};

export const saveAppSettings = (settings: AppSettings) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(
    APP_SETTINGS_KEY,
    JSON.stringify({
      ocrApiKeys: normalizeList(settings.ocrApiKeys || []),
      ncbiApiKey: settings.ncbiApiKey,
      ncbiEmail: settings.ncbiEmail,
      ncbiTool: settings.ncbiTool?.trim() || DEFAULT_APP_SETTINGS.ncbiTool,
    })
  );
};
